<template>
  <div>
      <div class="header-actions">
        <div>
          <md-button
            class="md-icon-button md-primary md-simple new-app-button"
            style="padding: 10px"
            @click="openVBIItemForm({})"
          >
          <md-icon id="new-app-icon">
            note_add
          </md-icon>
            New VBI Rule
          <md-tooltip md-direction="top">
            Add new VBI
          </md-tooltip>
          </md-button>
          <loading-icon-button
            tooltip="Refresh"
            style="padding: 10px"
            @click="getVBIList"
          >
            refresh
          </loading-icon-button>
        </div>
      </div>

      <v-text-field
            v-model="search"
            append-icon="search"
            label="Search Lender"
            single-line
            hide-details
      ></v-text-field>
      <v-data-table
        class="vbi-table"
        :headers="vbiHeader"
        :items="vbiItemData"
        :items-per-page="20"
        :search="search"
        title="VBI Rules"
        filterable
      >
        <template v-slot:item.rule_action="{ item }">
          <LoadingIconButton
            tooltip="Edit this VBI Rule"
            @click="openVBIItemForm(item)"
          >
            edit
          </LoadingIconButton>
          <LoadingIconButton
            tooltip="Delete this VBI Rule"
            @click="deleteVBIRule(item)"
          >
            clear
          </LoadingIconButton>
        </template>
      </v-data-table>

    <!-- Edit Form for VBI Rules -->
    <md-dialog :md-active.sync="showVBIEditForm">
      <div class="dialogWrapper">
        <ValidationObserver v-slot="{ invalid }">
          <md-dialog-title>
            {{ isNewVBIObject ? 'Create an VBI Rule' : 'Edit ' + vbiItem.lender["lender_name"]  }}
          </md-dialog-title>
          <br />
          <div class="md-layout input-table">
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                      <label for="rate-two-field">Lender ID</label>
                      <md-input id="rate-two-field"
                              v-model="vbiItem.lender_id"/>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">NAF Target 1</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.naf_target_1"/>
                      </md-field>
                  </div>
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">Reward Target 1</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.reward_target_1"/>
                      </md-field>
                  </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">NAF Target 2</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.naf_target_2"/>
                      </md-field>
                  </div>
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">Reward Target 2</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.reward_target_2"/>
                      </md-field>
                  </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">NAF Target 3</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.naf_target_3"/>
                      </md-field>
                  </div>
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">Reward Target 3</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.reward_target_3"/>
                      </md-field>
                  </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">NAF Target 4</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.naf_target_4"/>
                      </md-field>
                  </div>
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">Reward Target 4</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.reward_target_4"/>
                      </md-field>
                  </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">NAF Target 5</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.naf_target_5"/>
                      </md-field>
                  </div>
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">Reward Target 5</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.reward_target_5"/>
                      </md-field>
                  </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">NAF Target 6</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.naf_target_6"/>
                      </md-field>
                  </div>
                  <div class="md-layout-item">
                      <md-field>
                          <label for="rate-two-field">Reward Target 6</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.reward_target_6"/>
                      </md-field>
                  </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.includes_gst"
                          class="md-layout-item"
                      >
                          Include GST?
                      </md-checkbox>
                    </div>
                    <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.includes_dof"
                          class="md-layout-item"
                      >
                          Include DOF?
                      </md-checkbox>
                    </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.includes_establishment_fees"
                          class="md-layout-item"
                      >
                          Include Establishment fee?
                      </md-checkbox>
                    </div>
                    <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.includes_risk"
                          class="md-layout-item"
                      >
                          Include Risk?
                      </md-checkbox>
                    </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.includes_ppsr"
                          class="md-layout-item"
                      >
                          Include PPSR?
                      </md-checkbox>
                    </div>
                    <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.includes_comms"
                          class="md-layout-item"
                      >
                          Include Comms?
                      </md-checkbox>
                    </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                      <md-field>
                        <label for="rate-two-field">X Loss Index</label>
                        <md-input id="rate-two-field"
                                  v-model="vbiItem.x_loss_index"/>
                      </md-field>

                    </div>
                    <div class="md-layout-item">
                      <md-checkbox
                          v-model="vbiItem.vbi_includes_gst"
                          class="md-layout-item"
                      >
                          VBI Includes GST?
                      </md-checkbox>
                    </div>
              </div>
              <br>
              <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-two-field">Lender Notes</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.lender_notes"/>
                    </md-field>
                    </div>
                    <div class="md-layout-item">
                      <md-field>
                        <label for="rate-two-field">Other Notes</label>
                          <md-input id="rate-two-field"
                                  v-model="vbiItem.other_notes"/>
                      </md-field>
                    </div>
              </div>
              <br>
          </div>
          <div v-if="invalid">
            <p class="error-message">Please enter valid data to save changes</p>
          </div>
          <md-dialog-actions>
            <md-button
              class="md-primary md-simple"
              @click="cancelVBIItemForm"
            >
              Cancel
            </md-button>
            <md-button
              class="md-primary"
              :disabled="isSlaRuleFormDisable(invalid)"
              @click="saveVBIRuleItemForm()"
            >
              {{ isNewVBIObject ? 'Save' : 'Update' }}
            </md-button>
          </md-dialog-actions>
        </ValidationObserver>
      </div>
    </md-dialog>

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
  components: {
    DataTable,
    LoadingIconButton,
    ...ValidatedInputs,
  },
  created() {
    this.getVBIList();
  },
  data() {
    return {
      search:'',
      isNewVBIObject: false,
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      showVBIEditForm: false,
      vbiItem: {},
      originalVBIRuleItem: {}, //initial state VBI Rule when page is loaded
      vbiHeader: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Lender",
          value: "lender.lender_name",
          valueFunction(item) {
            return ((item.lender != NULL) ? item.lender["lender_name"] : "NULL");
          },
        },
        {
          text: "Target 1",
          value: "naf_target_1",
        },
        {
          text: "Reward 1",
          value: "reward_target_1",
        },
        {
          text: "Target 2",
          value: "naf_target_2",
        },
        {
          text: "Reward 2",
          value: "reward_target_2",
        },
        {
          text: "Target 3",
          value: "naf_target_3",
        },
        {
          text: "Reward 3",
          value: "reward_target_3",
        },
        {
          text: "Target 4",
          value: "naf_target_4",
        },
        {
          text: "Reward 4",
          value: "reward_target_4",
        },
        {
          text: "Target 5",
          value: "naf_target_5",
        },
        {
          text: "Reward 5",
          value: "reward_target_5",
        },
        {
          text: "Target 6",
          value: "naf_target_6",
        },
        {
          text: "Reward 6",
          value: "reward_target_6",
        },
        {
          text: "Include GST?",
          value: "includes_gst",
          valueFunction(item) {
            return ((item.includes_gst == "1") ? "Yes" : "No");
          },
        },
        {
          text: "Include DOF?",
          value: "includes_dof",
          valueFunction(item) {
            return ((item.includes_dof == "1") ? "Yes" : "No");
          },
        },
        {
          text: "Include Establish Fee?",
          value: "includes_establishment_fees",
          valueFunction(item) {
            return ((item.includes_establishment_fees == "1") ? "Yes" : "No");
          },
        },
        {
          text: "Include Risk?",
          value: "includes_risk",
          valueFunction(item) {
            return ((item.includes_risk == "1") ? "Yes" : "No");
          },
        },
        {
          text: "Include PPSR?",
          value: "includes_ppsr",
          valueFunction(item) {
            return ((item.includes_ppsr == "1") ? "Yes" : "No");
          },
        },
        {
          text: "VBI Include GST?",
          value: "vbi_includes_gst",
          valueFunction(item) {
            return ((item.vbi_includes_gst == "1") ? "Yes" : "No");
          },
        },
        {
          text: "VBI Include Comms?",
          value: "includes_comms",
          valueFunction(item) {
            return ((item.includes_comms == "1") ? "Yes" : "No");
          },
        },
        {
          text: "Lender Notes",
          value: "lender_notes",
        },
        {
          text: "X Loss Index",
          value: "x_loss_index",
        },
        {
          text: "Review Date",
          value: "review_date",
        },
        {
          text: "Other Notes",
          value: "other_notes",
        },
        {
          text: "Action",
          value: "rule_action",
        }
      ],
      vbiItemData: [],
    };
  },
  methods: {
    isSlaRuleFormDisable(invalid) {
      // check for modifying and validation data
      if (JSON.stringify(this.vbiItem) === JSON.stringify(this.originalVBIRuleItem) || invalid)
        return true;

      return false;
    },
    async getVBIList() {
      await axios.get(`/api/v1/administration/vbi_plans`)
        .then(res => {
          this.vbiItemData = res.data;
        })
        .catch(err => {
          console.log("Error getting vbiItemData", err);
          this.showUserDialog("Seems like a small problem with getting data..", err.response.data.error);
        });
    },
    showUserDialog(title, message) {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
    },
    openVBIItemForm(selectedItem) {
      // we understand new or existing object to save
      this.isNewVBIObject = (Object.keys(selectedItem).length === 0) ? true : false;
      // add into object nullable fields, otherwise will get eloquent error
      this.vbiItem = selectedItem;
      this.originalVBIRuleItem = { ...selectedItem };
      this.showVBIEditForm = true;
    },
    async deleteVBIRule(selectedItem) {
      await axios.delete(`/api/v1/administration/vbi_plans/${selectedItem.id}`)
        .then(res => {
          // if success need a fresh list
          this.getVBIList();
          this.showUserDialog(`${selectedItem.name} VBI Rule has been deleted!`, "");
        })
        .catch(err => {
          console.error("Delete VBI Rule Item request failed", err);
          this.showUserDialog("Seems like a small problem with deleting this sla Rule...", err.response.data.error);
        });
    },
    async saveVBIRuleItemForm() {
      // we have a new object
      if (this.isNewVBIObject) {
        await axios.post(`/api/v1/administration/vbi_plans`, this.vbiItem)
          .then(res => {
            this.showUserDialog("Сongratulations", ` New VBI plan has been created.`);
            // if success need a fresh list
            this.getVBIList();
          })
          .catch(err => {
            console.error("Create New VBI Rule form request failed", err);
            this.showUserDialog("Seems like a small problem with creating a new VBI Rule...", err.response.data.error);
          });
      }
      else {
        // we have an updated object
        await axios.patch(`/api/v1/administration/vbi_plans/${this.vbiItem.id}`, this.vbiItem)
          .then(res => {
            this.showUserDialog(`New VBI Plan has been updated.`, "");
          })
          .catch(err => {
            console.error("Failed to complete the request to update the VBI Plan edit form.", err);
            this.showUserDialog("Seems like a small problem with updating this VBI Plan edit form...", err.response.data.error);
            // if failed must return original state of the form
            this.getVBIList();
          });
      }
      this.showVBIEditForm = false;
    },
    cancelVBIItemForm() {
      // if cancel clicked and form has been modified, must return original state of the form
      if (JSON.stringify(this.vbiItem) !== JSON.stringify(this.originalVBIRuleItem)) {
        this.getVBIList();
      }
      this.showVBIEditForm = false;
    },
    ...filters
  },
  computed: {
    ...mapGetters([
      'options',
    ]),

  },
  filters: {
    ...filters
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.dialogWrapper {
  padding: 30px;
  overflow: scroll
}

.error-message {
  color: red;
  padding: 6px;
  margin: 15px 30px;
  text-align: center;
}

.vbi-table {
  margin: 0;
  overflow: scroll;
  overflow-y: hidden;
}

.header-actions {
  display: flex;
  justify-content: flex-end;
}

.input-table {
  display: grid;
}
</style>